'use client'

import { useState } from 'react'
import dynamic from 'next/dynamic'
import DebugPanel from './DebugPanel'
import { defaultParams, type SceneParams } from './scene-params'

const HeroCanvas = dynamic(() => import('./HeroCanvas'), {
  ssr: false,
  loading: () => null,
})

export default function HeroScene() {
  const [params, setParams] = useState<SceneParams>(defaultParams)

  return (
    <>
      <DebugPanel params={params} setParams={setParams} />
      <HeroCanvas params={params} />
    </>
  )
}
